import { useGlobalContext } from '../context'

function MainPage() {
    const {players, changePlayerCount,changeVampireCount, changeName, startGame, classHandler} = useGlobalContext();
    return (
        <div className='container border w-100'>
            <h2 className='text-center headline'>Vampire vs. Villagers by bergalii</h2>
            <div className="input-group mt-0">
                <button disabled='disable' className='btn btn-dark count'>Player Count</button>
                <select onChange={(e) => changePlayerCount(e.target.value)} className="custom-select rounded" id="inputGroupSelect01">
                    <option defaultValue="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                </select>
                <button disabled='disable' className='btn btn-dark count rounded'>Vampire Count</button>
                <select onChange={(e) => changeVampireCount(e.target.value)} className="custom-select" id="inputGroupSelect01">
                    <option defaultValue="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            <div className="input-group classes">
                <div className="custom-control custom-switch mt-2 mb-2 ml-4">
                            <input onClick={() => classHandler ('doctor')} type="checkbox" className="custom-control-input" id="customSwitch1"/>
                            <label className="custom-control-label white class" htmlFor="customSwitch1">Plague Doctor</label>
                </div>
                <div className="custom-control custom-switch mt-2 mb-2 ml-4">
                            <input onClick={() => classHandler('deadfucker')} type="checkbox" className="custom-control-input" id="customSwitch2"/>
                            <label className="custom-control-label white class" htmlFor="customSwitch2">Dead Fucker</label>
                </div>
                <div className="custom-control custom-switch mt-2 mb-2 ml-4">
                            <input onClick={() => classHandler('werewolf')} type="checkbox" className="custom-control-input" id="customSwitch3"/>
                            <label className="custom-control-label white class" htmlFor="customSwitch3">Werewolf</label>
                </div>
                <div className="custom-control custom-switch mt-2 mb-2 ml-4">
                            <input onClick={() => classHandler('darkmatter')} type="checkbox" className="custom-control-input" id="customSwitch4"/>
                            <label className="custom-control-label white class" htmlFor="customSwitch4">Dark Matter</label>
                </div>
            </div>
            <div className='names'>
                {
                    players.map((player, index) => {
                        return (
                            <div key={index} className="input-group input-group-sm mb-3 name-input rounded">
                                <button disabled='disable' className='btn btn-dark playernumber'>{index + 1}.</button>
                                <input type="text" className="form-control name" value={player.name} placeholder='Name' onChange={(e) => changeName(e, index)} />
                            </div>
                       )
                   }) 
                }
            </div>
            <button className='btn btn-dark  next' onClick={startGame}>Play</button>
        </div>
    )
}

export default MainPage;